import sign from '../utils/sign';
import LoginBase from './LoginBase';

export default class LoginProxy extends LoginBase {
  constructor(login) {
    super();
    this._login = login;
    this.VERSION = login.VERSION;
    this.buildCSRF = login.buildCSRF.bind(login);
    this.loginType = login.loginType.bind(login);
    this.isLogin = login.isLogin.bind(login);
    this.isWXLogin = login.isWXLogin.bind(login);
    this.isPhoneLogin = login.isPhoneLogin.bind(login);
    this.isNewQQLogin = login.isNewQQLogin.bind(login);
    this.isStrictLogin = login.isStrictLogin.bind(login);
    this.isFamilyChildLogin = login.isFamilyChildLogin.bind(login);
    this.getVuid = login.getVuid.bind(login);
    this.getUid = login.getUid.bind(login);
    this.getLoginInfo = login.getLoginInfo.bind(login);
    this.getMainCookie = login.getMainCookie.bind(login);
    this.getMainUserInfo = login.getMainUserInfo.bind(login);
    this.logout = login.logout.bind(login);
    this.openLogin = login.openLogin.bind(login);
    this.checkUser = login.checkUser.bind(login);
    this.checkFamilyChildLogin = login.checkFamilyChildLogin.bind(login);
    this.sign = sign;
    this.source = login.source;
  }
  setConfig(...args) {
    return this._login.setConfig(...args);
  }
  init(...args) {
    return this._login.init(...args);
  }
  onInit(...args) {
    return this._login.onInit(...args);
  }
  loginType(...args) {
    return this._login.loginType(...args);
  }
  isLogin(...args) {
    return this._login.isLogin(...args);
  }
  isStrictLogin(...args) {
    return this._login.isStrictLogin(...args);
  }
  isPTLogin(...args) {
    return this._login.isPTLogin(...args);
  }
  isQQLogin(...args) {
    return this._login.isQQLogin(...args);
  }
  isNewQQLogin(...args) {
    return this._login.isNewQQLogin(...args);
  }
  isWXLogin(...args) {
    return this._login.isWXLogin(...args);
  }
  isPhoneLogin(...args) {
    return this._login.isPhoneLogin(...args);
  }
  openLogin(...args) {
    return this._login.openLogin(...args);
  }
  logout(...args) {
    return this._login.logout(...args);
  }
  checkUser(...args) {
    return this._login.checkUser(...args);
  }
  checkFamilyChildLogin(...args) {
    return this._login.checkFamilyChildLogin(...args);
  }
  getMainUserInfo(...args) {
    return this._login.getMainUserInfo(...args);
  }
  getMainCookie(...args) {
    return this._login.getMainCookie(...args);
  }
  getLoginInfo(...args) {
    return this._login.getLoginInfo(...args);
  }
  getUin(...args) {
    return this._login.getUin(...args);
  }
  getUid(...args) {
    return this._login.getUid(...args);
  }
  getVuid(...args) {
    return this._login.getVuid(...args);
  }
  getToken(...args) {
    return this._login.getToken(...args);
  }
  buildCSRF() {
    return this._login.buildCSRF();
  }
  setLogin(login) {
    this._login = login;
  }
}
